const FormatFilter: any = [
   "7",
  "10",
  "12",
 "LP",
  "CD",
  // "Cassette",
  // "Merch",
];

export default FormatFilter;
